import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { AppService } from '../../app.service';

const API_ENDPOINT = '/api/translation/';

@Injectable({
  providedIn: 'root',
})
export class TranslationService {

  public translations: object;
  public translationsSubject: BehaviorSubject<object> = new BehaviorSubject<object>(void 0);
  public translationsPerTheme: Map<string, {}>;

  /**
   * Constructor
   *
   * @param {HttpClient} http
   * @param {TranslateService} translateService
   * @param {AppService} appService
   */
  public constructor(private http: HttpClient, private translateService: TranslateService, private appService: AppService) {
    this.translationsPerTheme = new Map<string, {}>();
  }

  /**
   * Load the translations
   *
   * @return {Observable<any>}
   */
  public loadTranslations(theme: string = null): Observable<any> {

    const baseUrl = theme
      ? (API_ENDPOINT + 'lang/' + this.appService.language + '/' + theme)
      : (API_ENDPOINT + 'lang/' + this.appService.language);

    return this.http.get(baseUrl)
    .pipe(
      map((response: object) => {
        this.translations = response;

        this.translateService.setTranslation(
          this.appService.language,
          this.translations,
        );

        this.translationsSubject.next(this.translations);
      }),
    );
  }

  /**
   * Load the translations
   *
   * @return {Observable<any>}
   */
  public loadTranslationsForAllThemes(): Observable<any> {
    const baseUrl = (API_ENDPOINT + 'lang/all-themes/' + this.appService.language);
    return this.http.get(baseUrl)
    .pipe(
      map((response) => {
        Object.keys(response).forEach((theme: string) => {
          this.translationsPerTheme.set(theme, response[theme]);
        });
      }),
    );
  }

  /**
   * Get the translation of the current Game
   *
   * @return Observable<any>
   */
  public loadCurrentTranslation(): Observable<any> {
    const baseUrl = (API_ENDPOINT + 'lang/current');
    return this.http.get(baseUrl)
      .pipe(
        map((response: any) => {

          console.log(response);

          this.translateService.setTranslation(
            response.language,
            response.translations,
          );

          this.translateService.use(response.language);

          this.translationsSubject.next(response.translations);
        }),
      );
  }

  /**
   * Loads the theme translations
   *
   * @param theme
   *
   * @return void
   */
  public loadTranslationsForTheme(theme: string): void {

    const translationsForTheme = this.translationsPerTheme.get(theme);

    this.translateService.setTranslation(
      this.appService.language,
      translationsForTheme,
    );

    // set default language as fallback
    const translationsDefault = this.translationsPerTheme.get('default');
    this.translateService.setTranslation(
      this.appService.language + '-fb',
      translationsDefault,
    );

    this.translateService.setDefaultLang(this.appService.language + '-fb');

    this.translationsSubject.next(translationsForTheme);
  }

}
